import { Field } from 'formik'
import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function Switch({ isChecked, name, form, onChange, onBlur, ...props }) {
  const handleChange = e => {
    onChange(e)
    form.setFieldTouched(name, true, false)
  }
  return (
    <div className={styles.wrapper}>
      <Field 
        type="checkbox" 
        as="input" 
        className={styles.field} 
        name={name}
        id={name}
        onChange={handleChange} 
        onBlur={onBlur} 
        {...props} 
      />
      <label htmlFor={name} className={cx(styles.label, { isChecked })} />
    </div>
  )
}
